import { gql } from '@apollo/client';

const TRANSACTION_TYPES_USER_PRICE_FRAGMENT = gql`
  fragment TransactionTypesUserPriceFragment on TransactionType {
    userPrice(user: $user) {
      priceInPerson
      priceRON
      company {
        id
        name
      }
    }
  }
`;

export default TRANSACTION_TYPES_USER_PRICE_FRAGMENT;
